import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Project } from 'src/app/model/project/project';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { ClientCornerMapRequestHelper } from './client-corner-map-request-helper';
import { Observable } from 'rxjs';
import { _get } from '../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class ClientCornerMapControllerRequestService {
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res) => res as Project[];
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get('/projects/client-map', requestServices);
  }

  public async clientMapProjects(
    companyId: number,
    filterType = ProjectClientMapFilterType.ALL
  ): Promise<Project[]> {
    const projects = await this.get(
      `/${companyId}/${filterType}`,
      this.deserialize
    ).toPromise();

    ClientCornerMapRequestHelper.processProjects(projects);
    return projects;
  }
}

export enum ProjectClientMapFilterType {
  ALL = 'ALL',
  AT_LEAST_ONE_ONGOING = 'AT_LEAST_ONE_ONGOING',
  SOLD_RENTED = 'SOLD_RENTED',
}
